import React from 'react'

const NotFound = () => {
  return <h3>404 - Not found</h3>;
};


export default NotFound;
